// Merkan · Englisches Wörterbuch: Hilfe, geführter Zugriff und Anleitungen im Wiki
export default {
  // Geführter Zugriff
  'Schritt {n} von {m}': 'Step {n} of {m}',
  'Geführten Zugriff unterbrechen': 'Pause guided tour',
  'Unterbrechen (Esc)': 'Pause (Esc)',
  'Dieses Element ist hier gerade nicht zu sehen.': 'This element is not visible here right now.',
  'Tippe auf das markierte Element': 'Tap the highlighted element',
  'Weiter': 'Next',
  'Zurück': 'Back',
  'Fertig': 'Done',

  // Hilfe-Symbol und Panel
  'Hilfe und Anleitungen': 'Help and guides',
  'Hilfe: geführter Zugriff unterbrochen bei Schritt {stand}': 'Help: guided tour paused at step {stand}',
  'Anleitungen durchsuchen': 'Search guides',
  'Weitermachen: {titel}': 'Continue: {titel}',
  'Fortsetzen': 'Resume',
  'Verwerfen': 'Discard',
  'Erledigt': 'Done',
  'Geführt zeigen': 'Show me',
  'Geführt zeigen: {titel}': 'Show me: {titel}',
  'Für diesen Mandanten nicht freigeschaltet': 'Not enabled for this tenant',
  'Keine passende Anleitung. Versuche ein anderes Stichwort.': 'No matching guide. Try another keyword.',
  'Noch keine Anleitungen.': 'No guides yet.',
  'Die Anleitungen konnten gerade nicht geladen werden.': 'The guides could not be loaded right now.',

  // Wiki: Reiter Anleitungen
  'Anleitungen': 'Guides',
  'Anleitungen zu jeder Funktion, mit Bildern für PC, Tablet und Handy und einem geführten Zugriff.': 'Guides for every feature, with pictures for desktop, tablet and phone and a guided tour.',
  'Alle Anleitungen': 'All guides',
  'Anleitung auswählen': 'Select a guide',
  'Links eine Anleitung wählen oder oben suchen.': 'Pick a guide on the left or search above.',
  'Anleitung nicht gefunden': 'Guide not found',
  'Sie ist für deine Rolle oder dein Unternehmen nicht freigeschaltet.': 'It is not enabled for your role or your company.',
  'Keine passende Anleitung': 'No matching guide',
  'Versuche ein anderes Stichwort.': 'Try another keyword.',
  'Noch keine Anleitungen': 'No guides yet',
  'Diese Funktion ist für diesen Mandanten nicht freigeschaltet. Du kannst die Anleitung lesen, der geführte Zugriff ist hier nicht möglich.': 'This feature is not enabled for this tenant. You can read the guide, but the guided tour is not available here.',
  'Für dieses Gerät gibt es noch keine Bilder.': 'There are no pictures for this device yet.',
  'PC': 'Desktop',
  'Tablet': 'Tablet',
  'Handy': 'Phone',
} satisfies Record<string, string>;
